import React from "react";

import {MuiIcon, MuiIconExternalProps} from './MuiIcon';

export const CheckIcon = (props: MuiIconExternalProps) => {
    return (
        <MuiIcon {...props}
        >{'\ue5ca'}</MuiIcon>
    );
}